import { Icon, Search,Modal,Dropdown,TextInput } from "pepsico-ds";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import requestsService from "./requestsservice";
import Tooltip from "../landing/tooltip";
import { Controller, useForm } from "react-hook-form";
import { useLoading } from "../../loader";
import { toast, ToastContainer } from "react-toastify";

// Define types for request options
interface RequestOption {
  label: string;
  desc: string;
  id: string;
  isBadge?: boolean;
  newApproverLevels?: Array<[]>;
  myidm?: boolean;
  currentAccessApp: boolean;
}

type DropdownItem = {
  id: string;
  displayText: string;
};

type Toast = {
  id: string;
  duration: number;
  text: string;
  type: string;
  position: string;
};

interface Props {
  onAppSelect: (app: RequestOption) => void;
  SearchedKeyword:(app:any) =>void;
}

const SearchForAnApplication: React.FC<Props> = ({ onAppSelect, SearchedKeyword,uid}) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState<string>("");
  const [requests, setRequests] = useState<RequestOption[]>([]);
  const [toasts, setToasts] = useState<Toast[]>([]);
  const [gpid, setGpid] = useState("");
  const [roleList, setRolesList] = useState([]);
  const [searchbyDivision, setSearchbyDivision] = useState(false);
  const [selectedRequestTabIndex, setSelectedRequestTabIndex] =
    useState<number>(0);
  const [selectedId, setSelectedId] = useState<RequestOption | null>(null);
  const [selectedItems, setSelectedItems] = useState<RequestOption[]>([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const[divisions,setDivisions]= useState<DropdownItem[]>([]);
  const[functions,setFunctions]= useState<DropdownItem[]>([]);
  const { showLoader, hideLoader } = useLoading();
  const[roles,setRoles]= useState<DropdownItem[]>([]);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedOption, setSelectedOption] = useState<RequestOption | null>(
    null
  );

  const handleSelect = (val: RequestOption) => {
    setSelectedOption(val);
  };

  const updateSearchText = (text: string) => {
    setSearchText(text);
  };
  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<{ my_selections: RequestOption[] }>({
    defaultValues: { my_selections: [] },
  });
  const getActionInfo = (res: { resetSelection?: boolean }): void => {
    console.log("getActionInfo called with:", res);
    if (res?.resetSelection) {
      setSelectedOption(null);
      setSelectedId(null);
      setRequests([]);
      setCheckedItems([]);
      setSelectedItems([]);
    }
  };
  const callGetRolesAPI = async (): Promise<void> => {
    try {
      showLoader();
      const currentAppList = await requestsService.getRolesList();
      setRolesList(currentAppList);
      const data = currentAppList["roleData"];
      const dropdownItems: DropdownItem[] = Object.keys(data).map((item) => ({
        id: item,
        displayText: item,
      }));

      setDivisions(dropdownItems);
      console.log("0909009090909090", divisions);
      hideLoader();
      // setRoles(roleItems);
    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
    }
  };
  const { control, setValue } = useForm();
  const data = JSON.parse(localStorage.getItem("okta-token-storage") ?? "{}");

  useEffect(() => {
    if(!uid){
      if (!gpid && data?.accessToken?.claims?.gpid) {
        setGpid(data?.accessToken?.claims?.gpid);
      }
    }
    else{
      setGpid(uid);
    }
    if(gpid){
      callGetRolesAPI();
    }
  }, [gpid]);

  const getAppRequestTypes = (val: string): void => {
    val = searchText;
    if (!val) return;

    if (val.length >= 3) {
      setSearchText(val);
      callSearchAPI(val);
    } 
    // else if (
    //   val.length > 3 &&
    //   val.substring(0, 3) === searchText.substring(0, 3)
    // ) {
    //   const results = requests.filter(
    //     (item) =>
    //       item.label.substring(0, val.length).toLowerCase() ===
    //       val.toLowerCase()
    //   );
    //   setRequests(results);
    // } 
    else {
      // setRequests([]);
      toast.info("Please enter at least 3 characters")
    }
  };
  const getRolesAppsAPI = async (): Promise<void> => {
    try {
      showLoader();
      const Jsondata = {
        division: selectedDivision[0]["id"],
        function: selectedFunction[0]["id"],
        role: selectedRole[0]["id"],
      };
      console.log('33333333333333333',Jsondata);
      
      const currentAppRoleList = await requestsService.getRoleAppList(Jsondata);
      // setSelectedId(currentAppList['appFormList']);
      // setSelectedItems(currentAppList['appFormList'])
      setSearchbyDivision(false);
      setRequests(currentAppRoleList);
      console.log('44444444444444444',currentAppRoleList['appFormList']);
      
      onAppSelect(currentAppRoleList);
      SearchedKeyword(Jsondata);
      hideLoader();
    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
    }
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e);
    
    // Clear Function and Role dropdowns when Division changes
    setSelectedFunction('');
    setSelectedRole('');
    setValue('function', []);
    setValue('role', []);
    setFunctions([]);
    setRoles([]);
    
    if(roleList && e && e.length > 0){
      const data = roleList['roleData'];
      const functionItems: DropdownItem[] =
      Object.keys(data[e[0]['id']]).map(func => ({
        id: func,
        displayText: func
      }))  
      setFunctions(functionItems);  
    }
  };

  const handleFunctionChange = (e) => {
    setSelectedFunction(e);
    
    // Clear Role dropdown when Function changes
    setSelectedRole('');
    setValue('role', []);
    setRoles([]);
    
    if(e && e.length > 0 && selectedDivision && selectedDivision.length > 0) {
      const data = roleList['roleData'];
      // Convert third-level values (roles) to DropdownItem[]
      const div = selectedDivision[0]['id'];
      const fun = e[0]['id'];
      const roleItems: DropdownItem[] = data[div][fun].map((role: string) => ({
          id: role,
          displayText: role
        }))

      setRoles(roleItems);
    }
  };

  const handleRoleChange = (e) => {
    setSelectedRole(e);
  };

  const onFormSubmit = (): void => {
    console.log('111111111111111','test');
    if (searchbyDivision) {
      getRolesAppsAPI();
    } else {
      setSelectedOption(selectedItems);
      if (selectedOption) {
        selectedOption["requestType"] = "NEW";
      }
    }
    setSelectedId(selectedItems);
    // setMode("NEW");
  };

  const showToast = (index: number, message: string, type: string) => {
    setToasts([
      {
        id: `toast-${index}`,
        duration: 10000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  const removeSelectedAPP = (item) => {
    setSelectedItems((prevSelected) =>
      prevSelected.filter((i) => i.id !== item.id)
    );
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };
  const closeModal = () =>{
    setSearchbyDivision(false);
  }
  const callSearchAPI = async (val: string): Promise<void> => {
    try {
      showLoader();
      const appList = await requestsService.getAppList(val, gpid);
      console.log("Fetched apps:", appList.length);

      if (appList.length === 0) {
        hideLoader();
        // showToast(1, "No applications matched the specified keyword.", "info");
        toast.info("No applications matched the specified keyword.")
      }
      const sortedApps = [...appList].sort((a, b) =>
        a.label.localeCompare(b.label)
      );
      onAppSelect(sortedApps); // Call parent function
      SearchedKeyword(val);
      setRequests(sortedApps);
      hideLoader();
    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
    }
  };

  return (
    <>
      <div className="search-for-an-application">
        <div className="search-seaction">
          <div className="search-title d-flex justify-content-center mb-2">
            {t("RequestNewAccessForSelf.search_for_an_application")}
          </div>
        </div>

        <div className="search-bar mb-2">
          <form
            className="w-100"
            onSubmit={handleSubmit(onFormSubmit)}
            style={{ display: "flex", gap: "1rem" }}
          >
            <Search
              //   value={searchText}
              isClearable={false}
              menuPosition="bottom-right"
              onClear={() => {
                setRequests([]);
                setSelectedItems([]);
              }}
            //   onSelectOption={(val: RequestOption) => setSelectedOption(val)}
              onSelectOption={handleSelect}
              onSearch={(val: string) => getAppRequestTypes(val)}
              onUpdate={updateSearchText}
              placeholderText={t(
                "RequestNewAccessForSelf.search_for_an_application"
              )}
              size="medium"
              isAutoComplete
              suggestions={requests}
            />
          </form>
        </div>

        <div className="search-bar-separation row">
          <div className="col-5 pr-0">
            <hr />
          </div>
          <div className="col-2 d-flex justify-content-center px-0 search-bar-separation-or">
            {t("RequestNewAccessForSelf.or")}
          </div>
          <div className="col-5 pl-0">
            <hr />
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2 row">
          <div className="col-auto align-self-center d-flex mb-3 mb-md-0 px-md-0" style={{alignItems:'center'}}>
            <button
              className="search-by-division-button my-0 mr-3 px-3"
              type="button"
              onClick={() => {
                setSearchbyDivision(true);
              }}
            >
              {t("RequestNewAccessForSelf.search_by_division")}
            </button>
            <Tooltip
              className=""
              direction="top"
              maxWidth="70px"
              style={{}}
              text="Select a Division, Function & Role to search for application names."
            >
            <Icon
              icon="info"
              size="large"
              className="d-flex align-items-center"
            />
            </Tooltip>
          </div>
        </div>
        <ToastContainer
          position="bottom-center"
          data={toasts}
          removeToast={removeToast}
        />
        <Modal
            className="search-division-modal"
            closeOnOutsideClick = {false}
            showModal={searchbyDivision}
            onCloseModal={()=>{
              closeModal();
              setSelectedDivision('');
              setSelectedFunction('');
              setSelectedRole('');
              setValue('division', []);
              setValue('function', []);
              setValue('role', []);
            }}
            primaryButtonProps={{
            onClick: () => {handleSubmit(onFormSubmit)()},
            size: 'medium',
            text: 'Search',
            variant: 'primary'
            }}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showLink={false}
            secondaryButtonProps={{
              onClick: () => {
                setSearchbyDivision(false);
                setSelectedDivision('');
                setSelectedFunction('');
                setSelectedRole('');
                setValue('division', []);
                setValue('function', []);
                setValue('role', []);
              },
              size: 'medium',
              text: 'Cancel',
              variant: 'secondary'
            }}
            
            style={{width:'350px'}}
            type="fluid"
            viewPort={"desktop"}
        >
            <div className="search-division" id="searchbydivision" style={{minWidth:'95%'}}>
            <h5 style={{fontSize:'16px'}} className="d-flex">Search by division</h5>
            <p style={{fontSize:'12px'}} className="d-flex">Select Accordingly</p>
            <form className="w-100" onSubmit={handleSubmit(onFormSubmit)}>
            <Controller
                name="division"
                control={control} 
                render={({ field }) => (
            <>
            <Dropdown
                childList={divisions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                className="mb-3"
                feedbackType="info"
                showLabelIcon={false}
                isClearable
                isRequired
                label="Division"
                menuPosition="bottom-right"
                placeholder="Search..."
                selection="single"
                selectedValue={field.value}
                setSelectedValue={(value) => {
                field.onChange(value);
                handleDivisionChange(value);
                }}
                size="medium"
                style={{}}
                onKeyDown={(e) => e.preventDefault()}
            />
            {errors['division'] && <span className="error">This field is required</span>}
            </>
            )}
            />
            <Controller
                name="function"
                control={control} 
                render={({ field }) => (
            <>
            <Dropdown
                key={`function-${Array.isArray(selectedDivision) && selectedDivision[0]?.id ? selectedDivision[0].id : 'empty'}`}
                childList={functions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                className="mb-3"
                feedbackType="info"
                isClearable
                isRequired
                showLabelIcon={false}
                label="Function"
                menuPosition="bottom-right"
                placeholder="Search..."
                selection="single"
                selectedValue={field.value}
                setSelectedValue={(value) => {
                field.onChange(value);
                handleFunctionChange(value);
                }}
                size="medium"
                style={{}}
                onKeyDown={(e) => e.preventDefault()}
            />
            {errors['function'] && <span className="error">This field is required</span>}
            </>
            )}
            />
            <Controller
                name="role"
                control={control} 
                render={({ field }) => (
            <>
            <Dropdown
                key={`role-${Array.isArray(selectedFunction) && selectedFunction[0]?.id ? selectedFunction[0].id : 'empty'}`}
                childList={roles?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                className="mb-3"
                feedbackType="info"
                isClearable
                isRequired
                showLabelIcon={false}
                label="Role"
                menuPosition="bottom-right"
                placeholder="Search..."
                selection="single"
                selectedValue={field.value}
                setSelectedValue={(value) => {
                field.onChange(value);
                handleRoleChange(value);
                }}
                size="medium"
                style={{}}
                onKeyDown={(e) => e.preventDefault()}
            />
            {errors['role'] && <span className="error">This field is required</span>}
            </>
            )}
            />
            </form>
            </div>
            
        </Modal>
      </div>
    </>
  );
};

export default SearchForAnApplication;
